(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-on-timeline"] && !Shopify.designMode) return;
  try {
    
(function(){
  function startOfDay(d){var x=new Date(d);x.setHours(0,0,0,0);return x}
  function endOfDay(d){var x=new Date(d);x.setHours(23,59,59,999);return x}
  function dateMatches(date,mode){
    if(mode==='all')return true;
    var now=new Date(),today=startOfDay(now),eventDay=startOfDay(date);
    if(mode==='today')return eventDay.getTime()===today.getTime();
    if(mode==='7-days'){var end=new Date(today);end.setDate(end.getDate()+7);return date>=today&&date<end}
    if(mode==='this-month')return date.getFullYear()===now.getFullYear()&&date.getMonth()===now.getMonth();
    if(mode==='next-month'){var next=new Date(now.getFullYear(),now.getMonth()+1,1),after=new Date(now.getFullYear(),now.getMonth()+2,1);return date>=next&&date<after}
    if(mode==='weekend'){
      var day=now.getDay(),daysToSaturday=(6-day+7)%7;
      var sat=startOfDay(now);sat.setDate(sat.getDate()+daysToSaturday);
      var mon=new Date(sat);mon.setDate(mon.getDate()+2);
      return date>=sat&&date<mon;
    }
    return true;
  }
  function init(root){
    if(root.dataset.filtersReady==='true')return;root.dataset.filtersReady='true';
    var form=root.querySelector('[data-wh-filters]'),cards=Array.from(root.querySelectorAll('[data-wh-card]')),headings=Array.from(root.querySelectorAll('[data-month-heading]'));
    var count=root.querySelector('[data-result-count]'),empty=root.querySelector('[data-filter-empty]');
    if(!form){if(count)count.textContent=cards.length;return}
    var category=form.querySelector('[data-filter-category]');
    if(category){var seen=new Set(['all']);Array.from(category.options).forEach(function(o){if(seen.has(o.value)){if(o.value!=='all')o.remove()}else seen.add(o.value)})}
    function apply(){
      var q=(form.querySelector('[data-filter-search]').value||'').trim().toLowerCase();
      var cat=category.value,dateMode=form.querySelector('[data-filter-date]').value,availability=form.querySelector('[data-filter-availability]').value,price=form.querySelector('[data-filter-price]').value,visible=0;
      cards.forEach(function(card){
        var eventDate=new Date(card.dataset.eventStart);
        var show=(!q||card.dataset.eventSearch.indexOf(q)>-1)&&(cat==='all'||card.dataset.eventCategory===cat)&&dateMatches(eventDate,dateMode)&&(availability==='all'||card.dataset.eventAvailability===availability)&&(price==='all'||card.dataset.eventPrice===price);
        card.hidden=!show;if(show)visible++;
      });
      headings.forEach(function(h){var month=h.dataset.monthHeading;h.hidden=!cards.some(function(c){return !c.hidden&&c.dataset.eventMonth===month})});
      count.textContent=visible;empty.hidden=visible!==0;
      form.querySelector('[data-clear-filters]').disabled=!q&&cat==='all'&&dateMode==='all'&&availability==='all'&&price==='all';
    }
    form.addEventListener('input',apply);form.addEventListener('change',apply);form.addEventListener('reset',function(){setTimeout(apply,0)});
    root.querySelector('[data-empty-clear]').addEventListener('click',function(){form.reset();apply();form.querySelector('[data-filter-search]').focus()});
    apply();
  }
  document.querySelectorAll('[data-wh-events]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){var root=e.target.querySelector('[data-wh-events]');if(root)init(root)});

  var lastTrigger=null;
  function fill(modal,card){var d=card.dataset,band=modal.querySelector('[data-wh-band]'),img=modal.querySelector('[data-wh-image]');if(d.image){img.src=d.image;img.alt=d.title||'';band.hidden=false}else{img.removeAttribute('src');band.hidden=true}modal.querySelector('[data-wh-cat]').textContent=d.category||'';modal.querySelector('[data-wh-title]').textContent=d.title||'';var when=d.when||'';if(d.time)when+=' · '+d.time;if(d.venue)when+=' · '+d.venue;modal.querySelector('[data-wh-when]').textContent=when;var text=modal.querySelector('[data-wh-text]');text.textContent='';[d.blurb,d.description].filter(Boolean).join('\n').split('\n').forEach(function(line){if(!line.trim())return;var p=document.createElement('p');p.textContent=line;text.appendChild(p)});modal.querySelector('[data-wh-price]').textContent=d.price||'';var chip=modal.querySelector('[data-wh-chip]');if(d.spaces){chip.textContent='Only '+d.spaces+' left';chip.hidden=false}else chip.hidden=true;var cta=modal.querySelector('[data-wh-cta]');cta.textContent=d.ctaLabel||'Details';if(d.state==='book'&&d.ctaUrl){cta.href=d.ctaUrl;cta.className='wah-button button';cta.removeAttribute('aria-disabled');if(d.ctaExternal==='true'){cta.target='_blank';cta.rel='noopener'}else{cta.removeAttribute('target');cta.removeAttribute('rel')}}else if(d.state==='free'||d.state==='info'){cta.href=d.page;cta.className='wah-button button button--secondary'}else{cta.href=d.page;cta.className='wh-modal__muted';cta.setAttribute('aria-disabled','true')}modal.querySelector('[data-wh-page]').href=d.page}
  function open(modal,card){fill(modal,card);modal.hidden=false;document.body.classList.add('wh-modal-open');modal.querySelector('[data-wh-close]').focus()}
  function close(modal){modal.hidden=true;document.body.classList.remove('wh-modal-open');if(lastTrigger){lastTrigger.focus();lastTrigger=null}}
  document.addEventListener('click',function(e){var card=e.target.closest('[data-wh-card]');if(card){var root=card.closest('[data-wh-events]'),modal=root&&root.querySelector('[data-wh-modal]');if(!modal)return;e.preventDefault();lastTrigger=card;open(modal,card);return}var closeButton=e.target.closest('[data-wh-close]');if(closeButton){var modal=closeButton.closest('[data-wh-modal]');if(modal)close(modal)}});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('[data-wh-modal]:not([hidden])').forEach(close)});
})();

  } catch(e) { console.error(e); }
})();
})();
